module.exports = __webpack_public_path__ + "img/set-document.e9809591.png";